module.exports = __webpack_public_path__ + "static/img/charge2.6afe8c4a.png";